import React, { useState } from 'react';
import { useTimeTableMonth } from '../../state/storeTimeTable';
import { usePostMeta } from '../../hooks/usePostMeta';
import ActivateHijra from './ActivateHijra';
import CalenderTypeHijra from './CalenderTypeHijra';
import LanguageHijra from './LanguageHijra';
import RamadanActivate from './RamadanActivate';
import { useConditional } from '../../state/storeConditional ';

const HijraOptions = () => {
    const { updateIsOnChangeInHijra, isOnChangeInHijra, isRamadan } = useConditional();
    const { HijraLocale } = useTimeTableMonth();
    const { appendDataPost } = usePostMeta();
    const [isLoading, setIsLoading] = useState(false); // Loading state

    // Check if the Save button should be disabled
    const isSaveDisabled =
        (HijraLocale.isActive && (!HijraLocale.lan || !HijraLocale.calenderType)) || // HijraLocale is incomplete
        (isRamadan.ramadan && (!HijraLocale.isActive || !HijraLocale.lan || !HijraLocale.calenderType)); // Ramadan is active but HijraLocale is incomplete

    const saveHandler = async () => {
        if (isLoading) return; // Prevent saving if already loading

        setIsLoading(true); // Start loading

        // Simulate a 2-second delay for the save operation
        setTimeout(async () => {
            try {
                // Save HijraLocale data regardless of its state (active or inactive)
                if (isOnChangeInHijra) {
                    updateIsOnChangeInHijra(false);
                    await appendDataPost({
                        meta: "hijralocale",
                        value: HijraLocale,
                    });
                }

                // Save Ramadan data regardless of its state (active or inactive)
                if (isOnChangeInHijra) {
                    updateIsOnChangeInHijra(false);
                    await appendDataPost({
                        meta: "ramadan",
                        value: isRamadan,
                    });
                }
            } catch (error) {
                console.error("Error saving data:", error);
            } finally {
                setIsLoading(false); // Stop loading after 2 seconds
            }
        }, 2000); // 2-second delay
    };

    return (
        <div className="w-2/6 bg-white flex flex-col">
            <ActivateHijra />
            {HijraLocale.isActive && (
                <>
                    <CalenderTypeHijra />
                    <br />
                    <LanguageHijra />
                    <br />
                    <RamadanActivate />
                </>
            )}

            {/* Save Button */}
            <button
                className={`px-5 py-2 m-2 ${
                    isSaveDisabled
                        ? 'bg-gray-400 cursor-not-allowed' // Disabled state
                        : isLoading
                        ? 'bg-green-500 text-white cursor-not-allowed' // Loading state
                        : 'bg-white text-green-500 border border-green-500' // Default state
                }`}
                onClick={saveHandler}
                disabled={isSaveDisabled || isLoading} // Disable the button if conditions are not met or loading
            >
                {isLoading ? (
                    <div className="flex items-center justify-center">
                        <svg
                            className="animate-spin h-5 w-5 mr-3 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                        </svg>
                        Saving...
                    </div>
                ) : (
                    'Save'
                )}
            </button>

            {/* Notification for the user */}
            {isSaveDisabled && (
                <p className="text-red-500 text-sm text-center mt-2 p-4">
                    {HijraLocale.isActive && (!HijraLocale.lan || !HijraLocale.calenderType)
                        ? "Please select a calendar type and language to save."
                        : "Please complete the HijraLocale settings to save Ramadan data. If you are deactivating the Hijra option, uncheck Ramadan to save the changes."}
                </p>
            )}
        </div>
    );
};

export default HijraOptions;